<script setup lang="ts">
import { computed } from 'vue';
import RexSelectV3 from '@/rex-components/RexSelectV3.vue';
import i18n from '@/plugins/i18n';
import { useStore } from 'vuex';
import { langSelectFieldOptions } from '@/components/Main/main.config';
import { useRouter } from 'vue-router';

const router = useRouter();
const store = useStore();
const getCurrLang = computed(
  () => store.getters['globalState/app/getCurrLang'],
);
const setCurrLang = (lang) => store.commit('globalState/app/setCurrLang', lang);

i18n.global.locale = getCurrLang.value;

function onLangChange(lang) {
  setCurrLang(lang);
  i18n.global.locale = lang;
  router.go(0);
}
</script>

<template>
  <div>
    <RexSelectV3
      :customStyle="{ width: '8rem' }"
      :value="getCurrLang"
      :options="langSelectFieldOptions"
      @onChange="onLangChange"
    />
  </div>
</template>

<style scoped></style>
